import {IntlShape, defineMessages} from 'react-intl'
import * as Yup from 'yup'

/**
 * Catálogo de Miembros (`/members`). Namespace `admin.*` (Fase 1.11).
 *
 * Casi todo reusa `common.*` y el catálogo de `admin.users.*`, que ya cubre los
 * mismos campos: aquí solo viven los textos propios de la pantalla.
 *
 * No se traducen: los nombres de rol (`node.name`) ni los mensajes de error del
 * backend, que llegan dentro de `common.error.withMessage`.
 */
export const MEMBER_MESSAGES = defineMessages({
  // ── Página ──
  title: {id: 'common.field.members', defaultMessage: 'Members'},
  add: {id: 'admin.members.action.add', defaultMessage: 'Add Member'},
  empty: {
    id: 'admin.members.empty',
    defaultMessage: 'There are no registered members',
  },
  thMember: {id: 'admin.members.th.member', defaultMessage: 'Member'},
  noRole: {id: 'admin.members.noRole', defaultMessage: 'No Rol'},

  // ── Modal ──
  // Frase completa por variante: en español no basta con cambiar el verbo
  // («Añadir un miembro» / «Editar el miembro»).
  modalAdd: {id: 'admin.members.action.add', defaultMessage: 'Add Member'},
  modalEdit: {id: 'admin.members.modal.edit', defaultMessage: 'Edit Member'},
  placeholderFirstName: {
    id: 'admin.members.placeholder.firstName',
    defaultMessage: 'Enter name',
  },
  placeholderLastName: {id: 'common.placeholder.enterLastName', defaultMessage: 'Enter last name'},
  placeholderEmail: {id: 'common.placeholder.enterEmail', defaultMessage: 'Enter email'},
  placeholderPhone: {id: 'admin.members.placeholder.phone', defaultMessage: 'Enter Phone'},
  toastCreated: {id: 'admin.members.toast.created', defaultMessage: 'Member added successfully'},
  toastUpdated: {id: 'admin.members.toast.updated', defaultMessage: 'Member updated successfully'},

  // ── Reusadas ──
  role: {id: 'admin.users.field.role', defaultMessage: 'Rol'},
  firstName: {id: 'common.field.firstName', defaultMessage: 'First Name'},
  lastName: {id: 'common.field.lastName', defaultMessage: 'Last Name'},
  email: {id: 'common.field.email', defaultMessage: 'Email'},
  phone: {id: 'common.field.phone', defaultMessage: 'Phone'},
  edit: {id: 'common.action.edit', defaultMessage: 'Edit'},
  close: {id: 'common.action.close', defaultMessage: 'Close'},
  saveChanges: {id: 'common.action.saveChanges', defaultMessage: 'Save changes'},
  selectOne: {id: 'admin.users.select.one', defaultMessage: 'Select One'},
  loading: {id: 'common.loading', defaultMessage: 'Loading...'},
  required: {id: 'common.hint.required', defaultMessage: '(required)'},
  errorWithMessage: {id: 'common.error.withMessage', defaultMessage: 'Error: {message}'},
  somethingWrong: {id: 'admin.users.toast.somethingWrong', defaultMessage: 'Something wrong!'},
})

/** Abreviatura de "no registrado": se escribe igual en EN y ES. */
export const NOT_RECORDED = 'N/R'

const VALIDATION = defineMessages({
  nameRequired: {id: 'validation.name.required', defaultMessage: 'Name is required'},
  lastNameRequired: {id: 'validation.lastName.required', defaultMessage: 'Last name is required'},
  roleRequired: {id: 'validation.role.required', defaultMessage: 'Role is required'},
  emailInvalid: {id: 'validation.email.invalid', defaultMessage: 'Invalid email'},
  phoneRequired: {id: 'validation.phone.required', defaultMessage: 'Phone is required'},
})

/** El schema es una función porque los mensajes se resuelven en render (guía §17.8). */
export const memberValidationSchema = (intl: IntlShape) =>
  Yup.object({
    name: Yup.string().required(intl.formatMessage(VALIDATION.nameRequired)),
    lastName: Yup.string().required(intl.formatMessage(VALIDATION.lastNameRequired)),
    rol: Yup.string().required(intl.formatMessage(VALIDATION.roleRequired)),
    email: Yup.string().email(intl.formatMessage(VALIDATION.emailInvalid)),
    cellphone: Yup.string().required(intl.formatMessage(VALIDATION.phoneRequired)),
  })
